import wishlistItemTemplate from 'templates/wishlists/item.mustache';

export default class AddToWishlist {
  constructor() {
    this.fetchWishlists();
    this.addListeners();
  }

  fetchWishlists() {
    var self = this;

    $.ajax({
      url: '/users/wishlists/',
      accept: 'application/json',
      cache: false,
      type: 'GET',
      error: function(jqXHR, textStatus, errorThrown) {
        console.log(' :( ' +  textStatus.toUpperCase()  + ' -- for ajaxAdd() : jqXHR.statusText = ' + jqXHR.statusText + ', textStatus = ' + textStatus);

      },
      success: function(data, textStatus, jqXHR) {
        self.addWishlistItems(data);
      }
    });
  }

  addWishlistItems(data) {
    $('.wishlist-items').each(function(index, element) {
      var productId = $(element).data("product-id");

      data.forEach(function(wishlistItem) {
        var $checkbox = wishlistItemTemplate.render({ productId: productId, wishlistId: wishlistItem.id, wishlistName: wishlistItem.name });
        $(element).append($checkbox);
      });
    });
  }

  addListeners() {
    $('.add-to-wishlist').on('click', this.toggleDropdown.bind(this));
    $(document).on('click', '.wishlist', this.addToWishlist.bind(this));
    $('.show-create-wishlist-modal').on('click', this.showWishlistModal.bind(this));
    $('#create-wishlist').on('click', this.submitCreateForm.bind(this));
  }

  toggleDropdown(event) {
    event.preventDefault();
    $(event.target).parent().find('.add-to-wishlist-content').toggleClass('closed');
  }

  addToWishlist(event) {
    if ($(event.target).prop('checked')) {
      this.sendAddRequest(event.target);
    } else {
      this.sendRemoveRequest(event.target);
    }
  }

  showWishlistModal(event) {
    event.preventDefault();
    $('#wishlist_product_id').val();
    $('#create-wishlist-modal').modal('show');
  }

  submitCreateForm(event) {
    event.preventDefault();

    var $form = $(event.target).closest("form");
    var title = $form.find('#wishlist_title').val();
    var description = $form.find('#wishlist_description').val();

    if (title === "") {
      alert('Please fill out form.');
    } else {
      this.sendCreateRequest(title, description);
    }

  }

  sendCreateRequest(title, description) {
    var self = this;
    $.ajax({
      url: '/users/wishlists/',
      accept: 'application/json',
      cache: false,
      type: 'POST',
      data: { title: title, description: description },
      error: function(jqXHR, textStatus, errorThrown) {
        console.log(' :( ' +  textStatus.toUpperCase()  + ' -- for ajaxAdd() : jqXHR.statusText = ' + jqXHR.statusText + ', textStatus = ' + textStatus);

      },
      success: function(data, textStatus, jqXHR) {
        self.wishlistCreated(data);
      }
    });
  }

  sendAddRequest(target) {
    var self = this;
    $.ajax({
      url: '/users/wishlists/' +  $(target).val() + '/add_product',
      accept: 'application/json',
      cache: false,
      type: 'POST',
      data: { product_id: $(target).data('productId') },
      error: function(jqXHR, textStatus, errorThrown) {
        console.log(' :( ' +  textStatus.toUpperCase()  + ' -- for ajaxAdd() : jqXHR.statusText = ' + jqXHR.statusText + ', textStatus = ' + textStatus);
        self.notifyError(target);

      },
      success: function(data, textStatus, jqXHR) {
        self.notifySuccess(target, 'SAVED');
      }
    });
  }

  sendRemoveRequest(target) {
    var self = this;
    $.ajax({
      url: '/users/wishlists/' +  $(target).val(),
      accept: 'application/json',
      cache: false,
      type: 'DELETE',
      xhrFields: {
         withCredentials: true
      },
      data: { product_id: $(target).data('productId') },
      error: function(jqXHR, textStatus, errorThrown) {
        console.log(' :( ' +  textStatus.toUpperCase()  + ' -- for ajaxAdd() : jqXHR.statusText = ' + jqXHR.statusText + ', textStatus = ' + textStatus);
        self.notifyError(target);

      },
      success: function(data, textStatus, jqXHR) {
        self.notifySuccess(target, 'REMOVED')
      }
    });
  }

  wishlistCreated(data) {
    var wishlistId = data['wishlist']['wishlist_id'];
    var wishlistName = data['wishlist']['wishlist_name'];

    $('#create-wishlist-modal').modal('hide');
    $('#wishlist_title').val('');
    $('#wishlist_description').val('');

    $('.wishlist-items').each(function(position, element) {
      var productId = $(element).data('product-id');

      var checkbox = wishlistItemTemplate.render({ productId: productId, wishlistId: wishlistId, wishlistName: wishlistName });

      $(element).append(checkox)
    });
  }

  notifySuccess(target, text) {
   var $label = $("label[for='" + $(target).attr('id') + "']");
   var wishlistName = $label.text();

   $label.text(text)
   $label.addClass('green');
   $(target).prop('disabled', true);

   setTimeout(function() {
     $label.text(wishlistName)
     $label.removeClass('green');
     $(target).prop('disabled', false);
   }, 3000);
  }

  notifyError(target) {
    var $label = $("label[for='" + $(target).attr('id') + "']");
    var wishlistName = $label.text();

    $label.text('ERROR')
    $label.addClass('red');
    $(target).prop('checked', function( i, val ) {
      return !val;
    });
    $(target).prop('disabled', true);

    setTimeout(function() {
      $label.text(wishlistName)
      $label.removeClass('red');
      $(target).prop('disabled', false);
    }, 3000);
  }
}
